/**
 * Cached active map resolution for route loaders (beforeLoad).
 * Module-level cache replaces TanStack Query's session caching.
 */
const API_BASE = import.meta.env.VITE_API_URL || "";

// Unbounded but safe: max ~5 entries per session (one per org visited)
const cache: Record<string, string> = {};

export async function resolveActiveMap(orgSlug: string): Promise<string> {
  if (cache[orgSlug]) return cache[orgSlug];

  const res = await fetch(`${API_BASE}/api/maps/active/${encodeURIComponent(orgSlug)}`);
  if (!res.ok) {
    throw new Error(`Failed to resolve active map for ${orgSlug}`);
  }

  const data: { mapSlug: string } = await res.json();
  cache[orgSlug] = data.mapSlug;
  return data.mapSlug;
}
